/**
 * Styled Components - Created by david on 12/02/18.
 */
import styled from 'styled-components'

interface DivProps {
  withCheckbox?: boolean
}

export const ImageContainer = styled.div`
  user-select: none;
  position: relative;
  height: 214.13px;
  width: 100%;
  padding: 10px;
  text-align: center;

  @media (min-width: 321px) and (max-width: 480px) {
    height: 100%;
    margin: 0;
  }
  @media only screen and (max-width: 320px) {
    height: 130px;
    margin: 0;
  }
`

export const Page = styled.div`
  user-select: none;
  height: 100%;
  text-align: center;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const Image = styled.img`
  user-select: none;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 3px;
  box-shadow: 1px 1px 5px 1px #a3a3a3;
  cursor: ${({ withCheckbox }: DivProps) => withCheckbox ? 'unset' : 'pointer'};
  @media (min-width: 321px) and (max-width: 480px) {
    height: 100%;
  }

  @media only screen and (max-width: 320px) {
    height: 120px;
    margin: 0;
  }
`

export const ImageTop = styled.div`
  user-select: none;
  position: absolute;
  top: 14px;
  left: 14px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductThumbnailInline/ProductImage/styledComponents.tsx